/**
 * Dynamic query for marketplace_typologies with filtering support
 */
const typologiesQuery = `
query MarketplaceTypologies($first: Int!, $skip: Int, $where: Marketplace_typologyWhereInput, $order: [Marketplace_typologyOrder!]) {
  marketplace_typologies(
    first: $first,
    skip: $skip,
    where: $where,
    order: $order
  ) {
    count
    edges {
      node {
        objectId
        name
        b2b
        b2c
        icon {
          name
          url
        }
        cover {
          name
          url
        }
        createdAt
        updatedAt
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default typologiesQuery;
